import type { ValueOf } from 'type-fest';

export const SCHEDULE_FREQUENCY = {
  UNSCHEDULED: 'unscheduled',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  BIWEEKLY: 'biweekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
} as const;

export type ScheduleFrequency = ValueOf<typeof SCHEDULE_FREQUENCY>;

// Maps UI frequency labels to integer days for the API
export const FREQUENCY_DAYS: Record<
  Exclude<ScheduleFrequency, 'unscheduled'>,
  number
> = {
  daily: 1,
  weekly: 7,
  biweekly: 14,
  monthly: 30,
  quarterly: 90,
} as const;

// Maps integer days from the API back to UI frequency labels
export const DAYS_TO_FREQUENCY: Record<number, ScheduleFrequency> = {
  1: 'daily',
  7: 'weekly',
  14: 'biweekly',
  30: 'monthly',
  90: 'quarterly',
} as const;

export type CardScheduleResponse = {
  id: number;
  cardId: number;
  askKlueAnswerId: string | null;
  prompt: string;
  researchMode: boolean;
  disabledSourceTypes: string[];
  frequencyDays: number | null; // null = paused/unscheduled
  lastUpdatedAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateCardSchedulePayload = {
  askKlueAnswerId?: string;
  prompt: string;
  researchMode: boolean;
  disabledSourceTypes: string[];
  frequencyDays: number | null;
  lastUpdatedAt?: string | null;
};

export type UpdateCardSchedulePayload = {
  prompt?: string;
  researchMode?: boolean;
  disabledSourceTypes?: string[];
  frequencyDays?: number | null; // null to pause
  lastUpdatedAt?: string | null; // null to clear and force update on next tick
};
